import React, { Component } from 'react';
import WaveGroup from './wavegroup';

const mobilemq_bp = 200;
const tabletmq_bp = 400;
const desktopmq_bp = 640;
const widemq_dp = 1200;

const mobileHeight = 320;
const tabletHeight = 480;
const desktopHeight = 640;
const wideHeight = 640;

class Canvas extends Component {
    constructor(props){
        super(props);
        this.state = {
          width: window.innerWidth,
          height: undefined,
        };
        this.pixelRatio = window.devicePixelRatio > 1 ? 2 : 1;
        requestAnimationFrame(this.animate.bind(this));
        this.canvas = React.createRef();
    }

    componentDidMount(){
      // window.addEventListener("resize",this.onWindowResize);
      window.addEventListener("heightSwitch",this.heightSwitch.bind(this));
      window.addEventListener('resize', this.resize.bind(this));

      this.canvas = this.refs.canvas;
      this.ctx = this.canvas.getContext('2d');
      this.waveNumbers = this.state.matches ? 5 : 4;
      this.waveHeight = this.state.matches ? 180 : 98;
      this.wavegroup = new WaveGroup(this.waveNumbers, this.waveHeight);
      this.resize();
      this.heightSwitch();
      this.animate();

    }

    componentWillUnmount(){
      window.removeEventListener("resize",this.resize.bind(this));
      window.removeEventListener("heightSwitch",this.onWindowResize);
      window.removeEventListener("animate",this.resize.bind(this));
      window.cancelAnimationFrame(this.animate.bind(this));
    }

    heightSwitch() {
      const checker = this.state.width;
      if(checker >= mobilemq_bp && checker < tabletmq_bp) {
        this.state.height = mobileHeight;

      } else if(checker >= tabletmq_bp && checker < desktopmq_bp){
        this.state.height = tabletHeight;

      } else if(checker >= desktopmq_bp && checker < widemq_dp){
        this.state.height = desktopHeight;

      } else if(checker >= widemq_dp) {
        this.state.height = wideHeight;
      }
      return this.state.height;
    }

    resize(){
        this.setState({ width: window.innerWidth, height: this.heightSwitch()});
        this.stageWidth = this.state.width;
        this.stageHeight = this.state.height;
        this.wavegroup.resize(this.stageWidth, this.stageHeight);
    }

    animate(){
        requestAnimationFrame(this.animate.bind(this));
        this.ctx.clearRect(0, 0, this.stageWidth, this.heightSwitch());
        this.wavegroup.draw(this.ctx, this.waveNumbers, this.waveHeight);
    }

    onWindowResize = () => {
        this.resize();
        this.heightSwitch();
    }

    render() {
        return(
            <div ref="artbox" className="artbg--wave" id="artWave">
                <canvas ref="canvas" width={this.state.width} height={this.state.height}/>
            </div>
        )
      }
  }

export default Canvas;



// WEBPACK FOOTER //
// ./src/layout/art/Canvas.js